import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { ProfessionalCategory } from '../../common/_types/professional-category';
import { ProfessionalCategoriesService } from '../../common/_services/professional-categories.service';

@Component({
    selector: 'app-professional-category-detail',
    templateUrl: './professional-category-detail.component.html',
    styleUrls: ['./professional-category-detail.component.scss'],
    standalone: false
})
export class ProfessionalCategoryDetailComponent {
  public professionalCategoryFormGroup!: RxFormGroup;

  public professionalCategory: ProfessionalCategory = new ProfessionalCategory();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private professionalCategoryService: ProfessionalCategoriesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
  ) {

    this.professionalCategoryFormGroup = this.formBuilder.formGroup<ProfessionalCategory>(this.professionalCategory) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de categoría profesional");
    this.topbarService.addBreadcrumb("Categorías profesionales", "/professional-categories");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadProfessionalCategory(id);
    } 

    this.allowWrite = this.loginService.hasPermission("PROFESSIONAL_CATEGORIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("PROFESSIONAL_CATEGORIES.DELETE");

  }

  async loadProfessionalCategory(id: string) {
    this.professionalCategory = await firstValueFrom(this.professionalCategoryService.get(id));
    this.professionalCategoryFormGroup.patchValue(this.professionalCategory);
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.professionalCategoryFormGroup);
    if (valid) {
      this.professionalCategory = Object.assign(this.professionalCategory, this.professionalCategoryFormGroup.value);
      let professionalCategory = await firstValueFrom(this.professionalCategoryService.save(this.professionalCategory));
      this.messageService.add({ closable: true, severity: 'success', summary: "Categoría profesional guardada correctamente." });
      this.router.navigate(['professional-categories']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la categoría profesional?",
      header: "Eliminar categoría profesional",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.professionalCategoryService.delete(this.professionalCategory.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Categoría profesional eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['professional-categories']);
  }
}
